import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import { useTranslation, Trans } from "react-i18next";

export default function Statute() {
    const { t } = useTranslation('statute')
    const statute = t("content", { returnObjects: true })

    const isStatuteContentArray = Array.isArray(statute) ? statute : [];
    const showStatute = isStatuteContentArray.map((paragraph) => (
        <p className="text-start pb-5">
            {
                Object.keys(paragraph).map((point, pointIndex) => {
                    return (<>
                        {point === "0" &&
                            <p className="text-center py-3"><h5 className="text-black"><strong>{Object.values(paragraph)[0] as string}</strong></h5></p>
                        }
                        {point !== "0" &&
                            <span className="text-start">{point} <Trans i18nKey={Object.values(paragraph)[pointIndex] as string}></Trans></span>
                        }
                    </>)
                })
            }
        </p>
    ))

    return (
        <Container className="text-center">
            <Row className="text-start">
                <Col xs={12}>
                    <Row>
                        <Col xs={12} xl={12}>
                            <Row className="text-start">
                                <Col xs={12} className="text-center mt-lg-5">
                                    <h1>
                                        <strong>
                                            {t('header')}
                                        </strong>
                                    </h1>
                                </Col>
                                <Col xs={12} className="ps-5 border-bottom border-warning mb-5"></Col>
                                {showStatute}
                            </Row>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Container>
    )
}